import './styles.css';

const ProductPrice = () => {

    return (
        <div className="product-price-container">
            <span>R$</span>
            <h3>2345.67</h3>
        </div>
    );
}

export default ProductPrice;
